import { Lock } from '@phosphor-icons/react';
import classNames from 'classnames';

import { SignupElement } from '@/signupElement';

import type { TPostSubscriberBreakProps } from './SubscriberBreak.types';

export const PostSubscriberBreak = (props: TPostSubscriberBreakProps) => {
  const { element, translations, homePath, loginPath, isLive, isLoading = false } = props;
  const attrs = element.attrs || {};
  const { title, message, cta, is_publication_private, site_settings } = attrs.data || {};

  return (
    <div
      className={classNames(
        'bg-wt-text-on-background text-wt-background mx-auto flex w-full flex-col items-center px-10 mb-10 py-10 max-w-2xl',
      )}
    >
      {is_publication_private && <Lock className="h-16 w-16" />}

      <div className="flex flex-col space-y-2">
        <h2 className="text-wt-background text-center text-3xl font-bold leading-tight tracking-normal">{title}</h2>
        <p className="text-wt-background text-center leading-tight tracking-normal">{message}</p>
      </div>
      <div className="w-full py-8">
        <SignupElement
          isSubmitting={isLoading}
          isLive={isLive}
          hasTermsOfService={site_settings?.terms_of_service_enabled || false}
          hasCustomTermsOfService={site_settings?.terms_of_service}
          gdprTranslations={{
            consentText:
              translations?.['shared.cta.gdpr_signup_consent'] || 'I consent to receive newsletters via email.',
            termsOfUseText: translations?.['footer.terms_of_use'] || 'Terms of Use',
            privacyPolicyText: translations?.['footer.privacy_policy'] || 'Privacy Policy',
            andText: translations?.['shared.cta.and'] || 'and',
            consentTextVariantTwo:
              `${translations?.['shared.cta.gdpr_signup_consent']} ${translations?.['shared.cta.sign_up']}` ||
              'I consent to receive newsletters via Email. Signup',
            termsOfServiceText: translations?.['meta.titles.tos'] || 'Terms of Service',
          }}
          element={{
            type: 'signup',
            attrs: {
              id: 'subscriber-break-static-signup-element',
              padding: 4,
              buttonBackgroundColor: 'var(--site-theme-primary-color)',
              buttonTextColor: 'var(--site-theme-text-on-primary-color)',
              backgroundColor: 'var(--site-theme-background-color)',
              borderStyle: 'var(--site-theme-border-style)',
              borderWidth: '2px',
              borderColor: 'var(--site-theme-border-color)',
              borderRadius: 'var(--site-theme-border-radius)',
              buttonBorderRadius: 'var(--site-theme-border-radius)',
              inputBackgroundColor: 'var(--site-theme-background-color)',
              inputPlaceholderColor: 'var(--site-theme-border-color)',
              inputTextColor: 'var(--site-theme-text-on-background-color)',
              gdprTextColor: 'var(--site-theme-text-on-primary-color)',
              buttonText: cta || translations?.['shared.cta.subscribe'],
              buttonSubmittingText: `${translations?.['shared.actions.submitting']}...`,
              inputPlaceholder: translations?.['subscribe.email_placeholder'],
              inputFontSize: '14px',
              buttonFontSize: '14px',
            },
            content: [
              {
                text: '',
                id: '',
              },
            ],
          }}
        >
          {null}
        </SignupElement>
      </div>
      <div className="pb-2">
        <span className="text-wt-background flex items-center justify-center text-center text-sm">
          {translations?.['login.already_a_subscriber']}
          <a href={loginPath} className="ml-1">
            <span className="underline underline-offset-1">{translations?.['shared.cta.sign_in']}</span>.
          </a>
        </span>
        <a href={homePath} className="cursor-pointer">
          <span className="text-wt-background flex justify-center py-2 text-center text-sm sm:text-lg">
            <span className="text-sm underline underline-offset-1">{translations?.['login.not_now']}</span>
          </span>
        </a>
      </div>
    </div>
  );
};
